var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[(_vm.isMobileOrTablet)?_c('small',{staticClass:"table--filterable__cell-header"},[_vm._v("\n    "+_vm._s(_vm.header)+"\n  ")]):_vm._e(),_vm._v(" "),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }